var _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolidGreenCompleted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 213,
    viewBox: "0 0 214 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_236_79)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.247 102.973C191.247 126.241 181.797 147.331 166.562 162.566C151.328 177.801 130.237 187.25 106.969 187.25C83.7006 187.25 62.6103 177.801 47.3756 162.566C32.1409 147.331 22.6914 126.241 22.6914 102.973C22.6914 79.7042 32.1409 58.6142 47.3756 43.3795C62.6103 28.1448 83.7006 18.6953 106.969 18.6953C130.237 18.6953 151.327 28.1448 166.562 43.3795C181.797 58.6142 191.247 79.7042 191.247 102.973Z",
    fill: "#8FB531"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_236_79)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.579 65.9938C146.887 63.3027 142.524 63.3027 139.833 65.9939L95.5847 110.242C92.8935 112.933 88.5302 112.933 85.839 110.242L74.2081 98.6114C71.5169 95.9202 67.1536 95.9203 64.4624 98.6115L59.3479 103.726C56.6567 106.417 56.6567 110.781 59.3479 113.472L85.839 139.963C88.5302 142.654 92.8935 142.654 95.5848 139.963L154.694 80.8544C157.385 78.1632 157.385 73.7998 154.694 71.1086L149.579 65.9938Z",
    fill: "#E2E2E2"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_236_79)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.005 206C107.002 206 107.001 206 107 206C79.4874 206 53.6218 195.286 34.168 175.831C33.0514 174.714 31.9597 173.573 30.8951 172.406C30.2806 171.733 30.3289 170.69 31.0011 170.076C31.6732 169.461 32.7174 169.51 33.3311 170.182C34.3621 171.312 35.4185 172.418 36.4999 173.499C55.3316 192.33 80.369 202.701 107 202.701C107.001 202.701 107.003 202.701 107.004 202.701C124.352 202.701 141.446 198.168 156.443 189.59C157.234 189.137 158.241 189.414 158.694 190.203C159.146 190.994 158.871 192.001 158.081 192.454C142.587 201.315 124.925 206 107.005 206ZM183.046 171.648C182.659 171.648 182.269 171.512 181.956 171.236C181.273 170.633 181.207 169.591 181.809 168.908C197.861 150.695 206.701 127.289 206.701 103V102.703C206.701 101.792 207.44 101.053 208.351 101.053C209.262 101.053 210 101.792 210 102.703V103C210 128.092 200.867 152.274 184.284 171.089C183.958 171.459 183.503 171.648 183.046 171.648ZM5.64937 104.723C4.73808 104.723 4 104.059 4 103.148V103C4 77.9628 13.0971 53.822 29.6146 35.0225C30.217 34.34 31.2575 34.2713 31.9426 34.8718C32.6269 35.4736 32.6939 36.5157 32.0933 37.2001C16.104 55.3967 7.29875 78.765 7.29875 103C7.299 103.911 6.56066 104.723 5.64937 104.723ZM181.786 36.2456C181.339 36.2456 180.894 36.0654 180.57 35.7102C179.569 34.6174 178.545 33.5474 177.499 32.5004C158.667 13.6696 133.63 3.29875 106.999 3.29875C106.998 3.29875 106.996 3.29875 106.995 3.29875C89.5956 3.29875 72.459 7.85649 57.4308 16.4821C56.6423 16.934 55.6325 16.6618 55.1788 15.8722C54.7259 15.0819 54.9984 14.0742 55.7887 13.6213C71.3142 4.71028 89.022 0 106.995 0C106.997 0 106.998 0 106.999 0C134.512 0 160.377 10.7137 179.831 30.1685C180.912 31.2489 181.97 32.3546 183.002 33.4825C183.617 34.1547 183.571 35.1978 182.899 35.8126C182.582 36.1024 182.184 36.2456 181.786 36.2456Z",
    fill: "#8FB531"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_236_79",
    x: 19.2458,
    y: 18.6953,
    width: 175.446,
    height: 175.446,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.44564
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.72282
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.164706 0 0 0 0 0.145098 0 0 0 0 0.133333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_236_79"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_236_79",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_236_79",
    x: 53.884,
    y: 63.9766,
    width: 106.274,
    height: 84.8952,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.44564
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.72282
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.164706 0 0 0 0 0.145098 0 0 0 0 0.133333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_236_79"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_236_79",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_236_79",
    x: 0.554365,
    y: 0,
    width: 212.891,
    height: 212.891,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.44564
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.72282
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.164706 0 0 0 0 0.145098 0 0 0 0 0.133333 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_236_79"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_236_79",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidGreenCompleted);
export default __webpack_public_path__ + "static/media/solidGreenCompleted.815e8f2a84710feb2fd9bb260b79e118.svg";
export { ForwardRef as ReactComponent };